export enum BUSINESS_TYPE_ENUM {
  YUNBANFANG = '1001',
  LVYUE = '1002',
  YUNGONGCHANG = '1003',
}
export const BUSINESS_TYPE_LIST = [
  { value: BUSINESS_TYPE_ENUM.YUNBANFANG, label: '云版房' },
  { value: BUSINESS_TYPE_ENUM.LVYUE, label: '供应链履约' },
  { value: BUSINESS_TYPE_ENUM.YUNGONGCHANG, label: '云工厂' },
];

export enum DEPARTMENT_TYPE_ENUM {
  YUNBANFANG = '1002',
  LVYUE = '1001',
  YUNGONGCHANG = '1003',
}
export const DEPARTMENT_TYPE_LIST = [
  { value: DEPARTMENT_TYPE_ENUM.YUNBANFANG, label: '创新版房开发部' },
  { value: DEPARTMENT_TYPE_ENUM.LVYUE, label: '创新履约开发部' },
  { value: DEPARTMENT_TYPE_ENUM.YUNGONGCHANG, label: '创新工厂开发部' },
];

export enum REVIEW_STATE_ENUM {
  UNREVIEW = '1',
  REVIEWINg = '2',
  REVIEWED = '3',
  REJECT = '4',
  WITHDRAW = '5',
  DELETE = '6',
}
export const REVIEW_STATE_LIST = [
  // { value: REVIEW_STATE_ENUM.UNREVIEW, label: '未审核' },
  { value: REVIEW_STATE_ENUM.REVIEWINg, label: '审核中' },
  { value: REVIEW_STATE_ENUM.REVIEWED, label: '通过' },
  { value: REVIEW_STATE_ENUM.REJECT, label: '拒绝' },
  // { value: REVIEW_STATE_ENUM.WITHDRAW, label: '撤回' },
  // { value: REVIEW_STATE_ENUM.DELETE, label: '删除' },
];

export enum ENVIRONMENT_TYPE_ENUM {
  DEV = '1',
  QA = '2',
  UAT = '3',
  PREPROD = '4',
  PROD = '5',
}
export const ENVIRONMENT_TYPE_LIST = [
  { value: ENVIRONMENT_TYPE_ENUM.DEV, label: '开发' },
  { value: ENVIRONMENT_TYPE_ENUM.QA, label: '测试' },
  { value: ENVIRONMENT_TYPE_ENUM.UAT, label: 'UAT' },
  { value: ENVIRONMENT_TYPE_ENUM.PREPROD, label: '灰度' },
  { value: ENVIRONMENT_TYPE_ENUM.PROD, label: '生产' },
];

export enum IS_DELETE_ENUM {
  YES = '1',
  NO = '0',
}
export const IS_DELETE_LIST = [
  { value: IS_DELETE_ENUM.YES, label: '是' },
  { value: IS_DELETE_ENUM.NO, label: '否' },
];
export const IS_RETAIN_LIST = [
  { value: IS_DELETE_ENUM.YES, label: '保留' },
  { value: IS_DELETE_ENUM.NO, label: '废弃' },
];
export enum APPROVAL_PROCESS_TYPE_ENUM {
  START = 'START',
  PASS = 'PASS',
  REJECT = 'REJECT',
  AUTO_PASS = 'AUTO_PASS',
  AUTO_REJECT = 'AUTO_REJECT',
  REMOVE_REPEAT = 'REMOVE_REPEAT',
  TRANSFER = 'TRANSFER',
  ADD_APPROVER_BEFORE = 'ADD_APPROVER_BEFORE',
  ADD_APPROVER = 'ADD_APPROVER',
  ADD_APPROVER_AFTER = 'ADD_APPROVER_AFTER',
  DELETE_APPROVER = 'DELETE_APPROVER',
  ROLLBACK_SELECTED = 'ROLLBACK_SELECTED',
  ROLLBACK = 'ROLLBACK',
  CANCEL = 'CANCEL',
  DELETE = 'DELETE',
  CC = 'CC',
  PENDING = 'PENDING',
}
export const APPROVAL_PROCESS_TYPE_LIST = [
  { value: APPROVAL_PROCESS_TYPE_ENUM.START, label: '审批开始' },
  { value: APPROVAL_PROCESS_TYPE_ENUM.PASS, label: '通过' },
  { value: APPROVAL_PROCESS_TYPE_ENUM.REJECT, label: '拒绝' },
  { value: APPROVAL_PROCESS_TYPE_ENUM.AUTO_PASS, label: '自动通过' },
  { value: APPROVAL_PROCESS_TYPE_ENUM.AUTO_REJECT, label: '自动拒绝' },
  { value: APPROVAL_PROCESS_TYPE_ENUM.REMOVE_REPEAT, label: '去重' },
  { value: APPROVAL_PROCESS_TYPE_ENUM.TRANSFER, label: '转交' },
  { value: APPROVAL_PROCESS_TYPE_ENUM.ADD_APPROVER_BEFORE, label: '前加签' },
  { value: APPROVAL_PROCESS_TYPE_ENUM.ADD_APPROVER, label: '并加签' },
  { value: APPROVAL_PROCESS_TYPE_ENUM.ADD_APPROVER_AFTER, label: '后加签' },
  { value: APPROVAL_PROCESS_TYPE_ENUM.DELETE_APPROVER, label: '减签' },
  { value: APPROVAL_PROCESS_TYPE_ENUM.ROLLBACK_SELECTED, label: '指定回退' },
  { value: APPROVAL_PROCESS_TYPE_ENUM.ROLLBACK, label: '全部回退' },
  { value: APPROVAL_PROCESS_TYPE_ENUM.CANCEL, label: '撤回' },
  { value: APPROVAL_PROCESS_TYPE_ENUM.DELETE, label: '删除' },
  { value: APPROVAL_PROCESS_TYPE_ENUM.CC, label: '抄送' },
  { value: APPROVAL_PROCESS_TYPE_ENUM.PENDING, label: '审批中' },
];

export enum SERVICE_TYPE_ENUM {
  /** 项目类型 H5, app, 小程序 */
  H5='1001',
  APP='1002',
  miniProgram ='1003',
}
export const HANDLE_SERVICE_TYPE_LIST = [
  { label: 'app', value: SERVICE_TYPE_ENUM.APP },
  { label: 'H5', value: SERVICE_TYPE_ENUM.H5 },
  { label: '小程序', value: SERVICE_TYPE_ENUM.miniProgram },
];
export enum FIRST_PEOPLE_ENUM {
  /** 带工号显示前端第一负责人 */
  DEVELOPMENT_FIRST = '1',
  /** 带工号显示前端备选负责人 */
  DEVELOPMENT_SECOND = '2',
  /** 带工号显示测试第一负责人 */
  TEST_FIRST = '3',
  /** 带工号显示测试备选负责人 */
  TEST_SECOND = '4'
}
